// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cookiePrivacyPolicyPopupStyles } from "@stoneage/Overrides/Components/CookiePrivacyPolicyPopup";
import { css } from "styled-components";
import { xScreen } from "@stoneage/XDL/Utilities";

cookiePrivacyPolicyPopupStyles.drawer = {
    position: "bottom",
    size: 100,
    isAutoSize: true,
    cssOverrides: {
        drawerTitle: css`
            display: none;
        `,
        drawerContent: css`
            padding: 16px 0;
            margin: 0 auto;
            width: 100%;
        `,
        scrim: css`
            @media print {
                display: none;
            }
        `,
    },
    closeButtonProps: {
        css: css`
            display: none;
        `,
    },
    enableClickThrough: true,
};

cookiePrivacyPolicyPopupStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 1fr auto;
        gap: 16px;
        ${xScreen("lt", "sm")} {
            grid-template-columns: 1fr;
        }
    `,
};

cookiePrivacyPolicyPopupStyles.messageGridItem = {};

cookiePrivacyPolicyPopupStyles.acceptGridItem = {
    css: css`
        display: flex;
        align-items: flex-start;
        justify-content: flex-end;
        gap: 16px;
    `,
};

cookiePrivacyPolicyPopupStyles.acceptButton = {
    variant: "primary",
};

cookiePrivacyPolicyPopupStyles.closeButton = {
    variant: "secondary",
};
